import React from 'react';
import { TableRowProps } from './table-row-props';
import { cx } from '@mint/core';
import styled from 'styled-components';

/**
 * List root class name.
 */
const ROOT_CLASS_NAME = 'table-row';

/**
 * Component to use.
 */
const DEFAULT_COMPONENT = 'div';

/**
 * List component implementation before styling.
 */
export const TableRowComponent = React.forwardRef<any, TableRowProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component: Component = DEFAULT_COMPONENT,
      ...rest
    } = props;

    const componentProps = {
      className: cx(ROOT_CLASS_NAME, className),
      ...rest,
      ref,
    };

    return <Component {...componentProps}>{children}</Component>;
  },
);

TableRowComponent.displayName = 'TableRow';

export const TableRow = styled(TableRowComponent)`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.palette.divider};
`;
